<template>
  <sp-confirm
    open
    cancelable
    confirm-label="Retry"
    width="700px"
    title="Error"
    @confirm="$emit('retry')"
    @cancel="$emit('cancel')"
  >
    <sp-alert type="error">
      <p>We encountered an error generating the content. Please try again.</p>
      <sup>({{ error.message }})</sup>
    </sp-alert>
  </sp-confirm>
</template>

<script setup>
defineEmits(["retry", "cancel"]);

defineProps({
  error: {
    type: Object,
    required: true,
  },
});
</script>
